<template>
    <div>
        <template v-if="pageloading">
            <v-container fluid
                         fill-height
                         class="d-flex align-center justify-center" style="position:absolute;z-index:99999;">
                <v-card tile >
                    <div class="text-center px-10 py-10">
                        <v-progress-circular :size="50"
                                             :width="5"
                                             :indeterminate="true"
                                             color="#B8354">
                                            </v-progress-circular>
                        <div class="mt-4 elevation-0">
                            <v-label>{{$t("loading")}}</v-label>
                        </div>
                    </div>
                </v-card>
            </v-container>
        </template>
        <v-card outlined class="elevation-0" v-if="!submitted" tile :loading="loading">
            <v-card-title class="cardtitle">
                
                <v-spacer />
            </v-card-title>
            <v-container v-if="survey" fluid class="formcontainer">

                <v-card-text>
                    <v-row align="center">

                        <v-col>
                            <h3>{{survey.name}}</h3>
                            <p class="pt-2">{{survey.description}}</p>
                            <!--<p>{{survey.estimatedTime}}</p>-->
                            <span class="secondary--text d-none" v-if="location">{{ location.coords.latitude }}, {{ location.coords.longitude}}</span>
                        </v-col>
                        <v-col cols="auto" v-if="viewMode || isLoggedIn">
                            <v-btn fab small class="white--text" color="secondary" @click="goBack">
                                <v-icon>mdi-arrow-left-circle</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card style="background-color:transparent" v-if="location" class="mb-5" id="editmap">
                    <v-card-title class="pa-3" style="cursor: pointer;" @click="isEditMapExpanded = !isEditMapExpanded">
                        <h4 class="form-label" color="black"> {{ gisLocationTitle }}</h4>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>{{ isEditMapExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-expand-transition>
                        <v-card-text tile v-if="isEditMapExpanded">
                            <v-row>
                                <v-col cols="12" class="pt-2 px-0">

                                    <div>
                                        <!--<small class="m-0 ms-2"> {{ question.note }}</small>

                        text-->

                                        <template>
                                            <div>
                                                <LocationPicker v-model='mapLocation' />
                                            </div>

                                        </template>
                                    </div>
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-expand-transition>
                </v-card>
                <!--<v-card-text class="d-block d-md-none pa-0" v-if="survey.pages.length>0 && !singlePageWithoutTitle">
        <v-col cols="12" class="pa-0">
            <v-card elevation="0" class="rounded-xl pa-6 d-flex d-column align-center" color="#F9FAFB">
                <v-progress-circular :rotate="360"
                                     :size="80"
                                     :width="6"
                                     :value="stepPercentage"
                                     color="#1B8354">
                    {{  surveyStepper+ " " + $t("of") + " " + survey.pages.length }}
                </v-progress-circular>
                <div class="ps-4">
                    <h4>
                        {{ currentpagename }}
                    </h4>
                </div>
            </v-card>
        </v-col>
    </v-card-text>-->

                <v-stepper v-if="survey" v-model="surveyStepper" elevation="0">
                    <v-stepper-header class="stepper-bg d-md-flex" v-if="survey.pages.length>0 && !singlePageWithoutTitle">
                        <template v-for="(page, stepIndex) in survey.pages">
                            <v-stepper-step class="pa-0" :key="'header' + stepIndex" :step="page.number" :complete="surveyStepper > stepIndex">
                                <span v-if="showpagetitle">{{page.name}}</span>
                            </v-stepper-step>
                            <v-divider v-if="stepIndex < survey.pages.length - 1" :key="'divider' + stepIndex" />
                        </template>
                    </v-stepper-header>
                    <v-stepper-items class="pa-2 flex-grow-1 stepper-bg gray mt-5">
                        <v-stepper-content class="ms-0 ps-0" :step="page.number" v-for="page in survey.pages" :key="page.number">
                            <v-form ref="surveyVoteForm" v-model="valid" lazy-validation>
                                <v-card style="background-color:transparent">



                                    <v-card-text tile>
                                        <v-row>
                                            <v-col :md="(question.questionTypeId ==bipolarMatrix || question.questionTypeId ==label || question.questionTypeId ==PictureChoice || question.questionTypeId ==textEditor)?'12':'12'" cols="12" v-for="(question, qIndex) in page.questions" v-show="filterPerRelatedQuestion(page, question) && (question.questionTypeId != bipolarMatrix || question.questionTypeId === bipolarMatrix && question.isParent)" :key="qIndex" class="pt-2 px-0">

                                                <div v-if="question.questionTypeId != bipolarMatrix">
                                                    <h4 class="form-label" color="black" v-if="question.questionTypeId != rating"> {{ getQuestionLabel(question) }}</h4>
                                                    <!--<small class="m-0 ms-2"> {{ question.note }}</small>

                                        text-->
                                                    <div v-if="question.questionTypeId == shortAnswer" class="options ">
                                                        <v-text-field outlined v-model="question.selectedValue" dense :disabled="question.voted" :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" />
                                                    </div>
                                                    <!--textEditor-->
                                                    <div class="options " v-html="question.questionTypeParams" v-if="question.questionTypeId == textEditor">

                                                    </div>
                                                    <!--number-->
                                                    <div v-if="question.questionTypeId == number" class="options ">
                                                        <v-text-field type="number" outlined v-model="question.selectedValue" dense :disabled="question.voted" :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" />
                                                    </div>

                                                    <!--label-->
                                                    <div v-if="question.questionTypeId == label" class="options ">
                                                        <v-label>{{question.default	}}</v-label>
                                                    </div>

                                                    <!--rating-->
                                                    <div class="options" v-if="question.questionTypeId == rating">
                                                        <v-row style="width:90%;margin:auto;" class="stepper-bg">
                                                            <h4 class="form-label" style="text-align:center;width:100%" color="black"> {{ getQuestionLabel(question) }}</h4>
                                                            <center style="width:100%">
                                                                <div style="width: auto; margin-top: 10px;margin:auto ">
                                                                    <v-rating v-model="question.selectedValue" center v-if="question.questionTypeParams === 'Star'" :length="rateLength" large @input="starClicked($event, question)"></v-rating>
                                                                    <SmileyRating v-model="question.selectedValue" v-if="question.questionTypeParams === 'Emoji'"></SmileyRating>
                                                                </div>
                                                            </center>
                                                        </v-row>
                                                    </div>

                                                    <!--YesNo-->
                                                    <div v-if="question.questionTypeId == yesNo" class="options ">
                                                        <LikeDislike v-model="question.selectedValue" :error="customComponentErrors[question.id] || false" :errorMessage="$t('RequiredField')"></LikeDislike>
                                                    </div>

                                                    <!--NPS-->
                                                    <div class="text-center" v-if="question.questionTypeId == nps">

                                                        <NPS :increaseDecrease="false" v-model="question.selectedValue" :defaultValue="question.questionTypeParams" :error="customComponentErrors[question.id] || false" :errorMessage="$t('RequiredField')"></NPS>
                                                    </div>

                                                    <!--date-->
                                                    <div v-if="question.questionTypeId == date" class="options ">
                                                        <DatePicker dense :outlined="outlined " v-model="question.selectedValue" :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" />
                                                    </div>

                                                    <!--textarea-->
                                                    <div v-if="question.questionTypeId == textArea" class="options ">
                                                        <v-textarea outlined v-model="question.selectedValue" :value="question.selectedValue" prepend-icon="mdi-format-align-justify"></v-textarea>
                                                    </div>

                                                    <!--hijri date-->
                                                    <div v-if="question.questionTypeId == HijriDate" class="options ">
                                                        <hijriDatePicker dense outlined v-model="question.selectedValue" :optionValue="question.questionTypeParams" :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []"></hijriDatePicker>
                                                    </div>

                                                    <!--PhoneNumber-->
                                                    <div v-if="question.questionTypeId == phoneNumber" class="options">
                                                        <phoneNumber :isAdmin="false" :mobileType="question.questionTypeParams" outlined v-model="question.selectedValue" prepend-icon="mdi-format-align-justify"></phoneNumber>
                                                    </div>

                                                    <!--Consent-->
                                                    <div class="text-center" v-if="question.questionTypeId == Consent">
                                                        <v-row align="center" no-gutters>
                                                            <v-col cols="auto">
                                                                <v-checkbox v-model="question.selectedValue" />
                                                            </v-col>

                                                            <v-col cols="auto">
                                                                <v-label>{{ question.questionTypeParams }}</v-label>
                                                            </v-col>
                                                        </v-row>
                                                    </div>

                                                    <!--EmailInput-->
                                                    <div v-if="question.questionTypeId == EmailInput" class="options ">
                                                        <emailInput outlined v-model="question.selectedValue" prepend-icon="mdi-format-align-justify"></emailInput>
                                                    </div>

                                                    <!--ContactForm-->
                                                    <div v-if="question.questionTypeId == ContactForm" class="options ">
                                                        <ContactFormComponent v-model="question.selectedValue" :isAdmin="false" @validation-state="handleCheckboxValidation" :validate="question.required" class="mt-3" @input="handleInputContact" outlined />
                                                    </div>

                                                    <!--Url-->
                                                    <div class="options " v-if="question.questionTypeId == Url">
                                                        <a style="color: #1B8354;" :href="question.questionTypeParams" target="_blank">{{question.questionTypeParams}}</a>
                                                    </div>

                                                    <!--UploadFiles-->
                                                    <div class="options " v-if="question.questionTypeId == UploadFiles">
                                                        <drag-drop-file-upload :viewMode="viewMode" v-model="question.selectedValue" :questId="question.id" :acceptedFileTypes="question.questionTypeParams" @upload-success="handleUploadSuccess" />
                                                    </div>

                                                    <!--PictureChoice-->
                                                    <div v-if="question.questionTypeId == PictureChoice" class="options ">
                                                        <publicPictureChoice v-if="question.questionPictures" v-model="question.questionPictures"></publicPictureChoice>
                                                    </div>
                                                    <div v-if="question.questionTypeId == CSAT5 || question.questionTypeId == CSAT3" class="options ">
                                                        <csatChoice v-if="question.options" v-model="question.selectedValue" :items="question.options"></csatChoice>
                                                    </div>
                                                    <!-- Ranking -->
                                                    <div v-if="question.questionTypeId == Ranking" class="options ">
                                                        <Ranking v-model="question.default" :options="question.questionTypeParams"></Ranking>
                                                    </div>

                                                    <!--Image-->
                                                    <div v-if="question.questionTypeId == image" class="text-center mt-3 options ">
                                                        <v-row>
                                                            <v-col cols="12">
                                                                <div style="width : 600px" v-if="question.imagePosition == 'middle'" class="ma-auto">
                                                                    <img v-if="question.default" :src="question.default" v-bind:style="{width: question.imageWidth + '%' }" :alt="previewMedia" />
                                                                </div>
                                                                <div style="width : 600px" v-if="question.imagePosition == 'end'" class="float-end text-end">
                                                                    <img v-if="question.default" :src="question.default" v-bind:style="{width: question.imageWidth + '%' }" :alt="previewMedia" />
                                                                </div>
                                                                <div style="width : 600px" v-if="question.imagePosition == 'start'" class="text-start">
                                                                    <!-- Display the preview image next to the input file element -->

                                                                    <img v-if="question.default" :src="question.default" v-bind:style="{width: question.imageWidth + '%' }" :alt="previewMedia" />
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </div>

                                                    <!--vedioLink-->
                                                    <div v-if="question.questionTypeId == vedioLink" class="text-center mt-3 options ">
                                                        <v-row>
                                                            <v-col cols="12" sm="6" md="6">

                                                                <h5 class=" secondary--text my-3"> {{ question.default }}</h5>

                                                                <template>

                                                                    <iframe v-if="question.default" width="640" height="360"
                                                                            :src="embedUrl(question.default)">
                                                                    </iframe>

                                                                </template>
                                                            </v-col>
                                                        </v-row>
                                                    </div>



                                                    <div v-if="question.questionTypeId == multipleChoice || question.questionTypeId == checkbox || question.questionTypeId == dropdown || question.questionTypeId == trickyQuestion">

                                                        <!--dropdown-->
                                                        <v-autocomplete :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" dense outlined v-if="question.questionTypeId == dropdown || question.questionTypeId == trickyQuestion" v-model="question.selectedValue" :items="question.options" item-value="id" item-text="name" :label="$t('Select')" />

                                                        <!--radio-->
                                                        <v-radio-group v-if="question.questionTypeId == multipleChoice" v-model="question.selectedValue" :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []">
                                                            <v-radio v-for="(option, optIndex) in question.options" :key="optIndex" :disabled="question.voted" :label="option.name" :value="option.id" />
                                                        </v-radio-group>

                                                        <!--checkbox-->
                                                        <template v-if="question.questionTypeId == checkbox">
                                                            <!--<p>{{ question.options }}</p>-->
                                                            <!--<ArrayCheckboxList v-if="question.selectedValue" v-model="question.selectedValue" :selectedValue="question.selectedValue" :options="question.options" :disabled="question.voted" dense />-->
                                                            <ArrayCheckboxList v-model="question.selectedValue" :selectedValue="question.selectedValue" :options="question.options" :disabled="question.voted" dense />
                                                            <!--<v-checkbox v-for="(option, chkIndex) in question.options" :key="chkIndex" v-model="question.selectedValue" :rules="question.required ? nameRules : []" :disabled="question.voted" dense :label="option.name" :value="option.id" />-->
                                                        </template>
                                                    </div>

                                                    <!--PredefineDropdown-->
                                                    <div v-if="question.questionTypeId == predefineDropdown" class="options">

                                                        <v-autocomplete :key="question.id" clearable :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" dense outlined
                                                                        v-model="question.selectedValue" :label="$t('Select')"
                                                                        :items="question.options" item-value="id" item-text="name"
                                                                        @change="handlePredefineDropdownChange(question, $event, true,question)" />

                                                        <template v-if="relatedPredefinedQuestions.filter(x=> x.id == question.id)[0]">
                                                            <v-col cols="4" v-for="(item, customIndex) in relatedPredefinedQuestions.filter(x=> x.id == question.id)[0].relatedQuestions" :key="customIndex">
                                                                <v-autocomplete clearable :rules="question.required && filterPerRelatedQuestion(page, question) ? nameRules : []" dense outlined
                                                                                v-model="item.selectedValue"
                                                                                :label="item.title"
                                                                                :items="item.options"
                                                                                item-value="id"
                                                                                item-text="name"
                                                                                @change="handlePredefineDropdownChange(question, $event, false, item)" />
                                                            </v-col>
                                                        </template>

                                                    </div>
                                                    <template v-if="question.questionTypeId == maps">
                                                        <div>
                                                            <!--<v-text-field outlined v-model="searchQuery" dense :disabled="question.voted" :placeholder="$t('SearchForAPlace')" @input="updateMap" />

                                                                                                        <gmap-map v-if="mapCenter" :center="mapCenter"
                                                          :zoom="mapZoom"
                                                          style="width: 100%; height: 500px;"
                                                          @click="placeMarker">
                                                    <gmap-marker :position="markerPosition" :clickable="false"></gmap-marker>
                                                </gmap-map>-->
                                                            <LocationPicker v-model='mapCenter' v-if="mapCenter" />
                                                        </div>
                                                        <div class="mt-3"><v-btn color="#1B8354" class="pa-4" elevation="0" @click="answerLocation(question)">{{$t('SetLocation')}}</v-btn></div>
                                                    </template>
                                                </div>
                                                <div v-if="question.questionTypeId === bipolarMatrix && question.isParent" class="mt-3 bipolar-matrix-container">
                                                    <!-- Desktop view - Table -->
                                                    <div class="bipolar-desktop-view">
                                                        <div class="table-wrapper">
                                                            <v-simple-table dense>
                                                                <template v-slot:default>
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-start bipolar-header-title"><h4>{{ getQuestionLabel(question) }}</h4></th>
                                                                            <th v-for="(answer, aIndex) in page.questions.filter(x => x.questionTypeId === bipolarMatrix && x.parentQuestionId == question.id)[1].options" :key="aIndex" class="text-center bipolar-header-option">
                                                                                {{ answer.name }}
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(q, qIndex) in page.questions.filter(x => !x.isParent && x.parentQuestionId == question.id)" :key="qIndex">
                                                                            <td class="bipolar-question-cell">{{ getQuestionLabel(q) }}</td>
                                                                            <td v-for="option in q.options" :key="option.id" class="bipolar-option-cell">
                                                                                <v-radio-group row dense v-model="q.selectedValue" @change="updateParentQuestion(qIndex, q.selectedValue, question)" hide-details class="ma-0">
                                                                                    <v-radio :value="option.id" class="d-block text-center mx-auto"></v-radio>
                                                                                </v-radio-group>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </div>
                                                    </div>

                                                    <!-- Mobile view - Card based -->
                                                    <div class="bipolar-mobile-view">
                                                        <h4 class="bipolar-mobile-title mb-4">{{ getQuestionLabel(question) }}</h4>
                                                        <v-card v-for="(q, qIndex) in page.questions.filter(x => !x.isParent && x.parentQuestionId == question.id)" :key="qIndex" class="bipolar-mobile-card mb-3" outlined>
                                                            <v-card-text>
                                                                <div class="bipolar-mobile-question-title mb-3">{{ getQuestionLabel(q) }}</div>
                                                                <v-radio-group v-model="q.selectedValue" @change="updateParentQuestion(qIndex, q.selectedValue, question)" hide-details>
                                                                    <div class="bipolar-mobile-options">
                                                                        <v-radio v-for="option in q.options" :key="option.id" :value="option.id" class="bipolar-mobile-radio">
                                                                            <template v-slot:label>
                                                                                <span class="bipolar-mobile-option-label">{{ option.name }}</span>
                                                                            </template>
                                                                        </v-radio>
                                                                    </div>
                                                                </v-radio-group>
                                                            </v-card-text>
                                                        </v-card>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                    <v-card-actions class="formactions">
                                        <v-btn v-if="surveyStepper > 1" outlined class="rounded-m pa-6" elevation="0" @click="previousStep(page.number)">
                                            {{ $t('Previous') }}
                                        </v-btn>
                                        <v-btn v-if="surveyStepper != steps" class="rounded-m pa-6 white--text" elevation="0" color="#1B8354" @click="nextStep(page.number)">
                                            {{ $t('Next') }}
                                        </v-btn>

                                        <v-btn v-if="surveyStepper == steps && !viewMode && !editMode" outlined class="rounded-m pa-6" elevation="0" @click="complete(true)">
                                            {{ $t('SaveForLater') }}
                                        </v-btn>
                                        <v-btn v-if="surveyStepper == steps && !viewMode" class="rounded-m pa-6 white--text" elevation="0" color="#1B8354" @click="complete(false)">
                                            {{ $t('Submit') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-stepper-content>
                    </v-stepper-items>

                </v-stepper>
            </v-container>
        </v-card>
        <v-card tile v-if="submitted">
            <v-card-text>
                <v-alert border="top" color="secondary" dark>
                    {{ $t('SurveySubmitted') }}
                </v-alert>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import survey from '@/plugins/router/routes/survey'

export default {
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
  },
  
        computed: {
            
    circumference() {
      return 2 * Math.PI * 18
    },
    progressOffset() {
      return this.circumference * (1 - this.surveyStepper / survey.pages.length)
    },
    
        },
        
}
</script>
<script>
    import { mapGetters } from 'vuex'
    import SurveyService from '@/services/SurveyService.js'
    import { FormMethodEnum } from '@/helpers/constants/enumerations.js'
    import DatePicker from '@/components/controls/DatePicker.vue'
    import LookupAdminService from '@/services/LookupAdminServices.js'
    import SmileyRating from '@/components/controls/SmileyRating.vue'
    import LocationPicker from '@/components/controls/LocationPicker.vue'
    import LikeDislike from '@/components/controls/LikeDislike.vue'
    import NPS from '@/components/controls/NPS.vue'
    import hijriDatePicker from '@/components/controls/PublicHijri.vue'
    import phoneNumber from '@/components/controls/phoneNumber.vue'
    import emailInput from '@/components/controls/EmailInput.vue'
    import publicPictureChoice from '@/components/controls/PublicPictureChoice.vue'
    import csatChoice from '@/components/controls/CSATChoice.vue'
    import ContactFormComponent from '@/pages/Admin/ContactForm.vue'
    import DragDropFileUpload from '@/components/controls/PublicFileUploader.vue'
    import ArrayCheckboxList from '@/components/controls/ArrayCheckboxList.vue'
    import Ranking from '@/components/controls/PublicRanking.vue'
    import Cookies from 'js-cookie'
    export default {
        components: {
            DatePicker, SmileyRating, LikeDislike, NPS, ArrayCheckboxList, hijriDatePicker, Ranking, phoneNumber, emailInput, publicPictureChoice, ContactFormComponent, DragDropFileUpload, csatChoice, LocationPicker
        },

        data() {
            return {
                currentpagename: null,
                singlePageWithoutTitle: false,
                //options: [{ 'id': 2301, 'name': '1', 'order': 0 }, { 'id': 2302, 'name': '2', 'order': 0 }],
                pageloading: true,
                valid: true,
                outlined: true,
                participantId: null,
                editMode: false,
                submitted: false,
                loading: false,
                location: null,
                gettingLocation: false,
                survey: null,
                surveyStepper: 1,
                steps: null,
                textEditor: FormMethodEnum.TextEditor,
                shortAnswer: FormMethodEnum.ShortAnswer,
                checkbox: FormMethodEnum.Checkboxes,
                multipleChoice: FormMethodEnum.MultipleChoice,
                dropdown: FormMethodEnum.Dropdown,
                trickyQuestion: FormMethodEnum.TrickyQuestion,
                predefineDropdown: FormMethodEnum.PredefineDropdown,
                bipolarMatrix: FormMethodEnum.BipolarMatrix,
                image: FormMethodEnum.Image,
                vedioLink: FormMethodEnum.VedioLink,
                label: FormMethodEnum.Label,
                rating: FormMethodEnum.Rating,
                number: FormMethodEnum.number,
                yesNo: FormMethodEnum.YesNo,
                date: FormMethodEnum.Date,
                nps: FormMethodEnum.NPS,
                HijriDate: FormMethodEnum.HijriDate,
                maps: FormMethodEnum.Maps,
                textArea: FormMethodEnum.TextArea,
                phoneNumber: FormMethodEnum.PhoneNumber,
                EmailInput: FormMethodEnum.EmailInput,
                PictureChoice: FormMethodEnum.PictureChoice,
                CSAT5: FormMethodEnum.CSAT5,
                CSAT3: FormMethodEnum.CSAT3,
                ContactForm: FormMethodEnum.ContactForm,
                Url: FormMethodEnum.Url,
                UploadFiles: FormMethodEnum.UploadFiles,
                Consent: FormMethodEnum.Consent,
                Ranking: FormMethodEnum.Ranking,
                nameRules: [v => !!v || this.$t('RequiredField')],
                relatedPredefinedQuestions: [],
                rated: null,
                rateLength: 5,
                previewMedia: this.$t('Preview'),
                startTime: null,
                viewMode: false,
                fromLanding: 'true',
                fromTask: 'false',
                fromAddSurvey: 'false',
                searchQuery: '',
                mapCenter: { lat: 0, lng: 0 },
                mapLocation: { lat: 0, lng: 0 },
                mapZoom: 16,
                isEditMapExpanded: false,
                markerPosition: null,
                selectedImages: {},
                selectedContactForm: '',
                isCheckboxValid: true,
                customComponentErrors: {},
                showpagetitle: true
            }
        },
        created() {
            if (this.$route.query.id) {
                if (this.$route.query.viewMode == 'true') {
                    this.loadSurveyPreview(this.$route.query.id)
                    this.viewMode = true
                } else {
                    this.loadSurveyForm(this.$route.query.id)

                }
                this.fromLanding = this.$route.query.fromLanding
                this.fromTask = this.$route.query.fromTask
                this.fromAddSurvey = this.$route.query.viewMode
                this.getLocation()
                this.startTime = new Date()


            }

        },
        computed: {
            ...mapGetters('user', ['language', 'isAuthenticated']),

            isLoggedIn() {
                return this.isAuthenticated && this.$route.name != 'login'
            },
            gisLocationTitle() {
                // Use custom GIS Integration Title if available, otherwise use default translation
                if (this.survey) {
                    const customTitle = this.language === 'ar' 
                        ? this.survey.gisintegrationTitleAr 
                        : this.survey.gisintegrationTitleEn
                    
                    if (customTitle) {
                        return customTitle
                    }
                }
                else
                    return this.$t('EditGISLocation')
            },
            getWidth(width) {
                return width + '%'
            },
            stepPercentage() {

                if (this.survey && this.survey.pages && this.survey.pages.length > 0) {

                    return this.surveyStepper / this.survey.pages.length * 100
                }
                else {
                    return 20
                }
            },
            getLanguage() {
                return this.language == null ? 'ar' : this.language
            },

            itemsForLookupRelatedParent() {
                return this.itemsParetRelated.map(item => ({ id: item.recordPK, name: item.nameEn }))
            },

            isYouTube() {
                return (videoUrl) => {
                    return videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')
                }
            },

            isVimeo(videoUrl) {
                return (videoUrl) => {
                    return videoUrl.includes('vimeo.com')
                }
            },

            embedUrl() {
                return (videoUrl) => {

                    if (this.isYouTube(videoUrl)) {
                        // Extract video ID from YouTube link
                        const videoId = this.getYouTubeVideoId(videoUrl)
                        return `https://www.youtube.com/embed/${videoId}`
                    } else if (this.isVimeo(videoUrl)) {
                        // Extract video ID from Vimeo link
                        const videoId = this.getVimeoVideoId(videoUrl)
                        return `https://player.vimeo.com/video/${videoId}`
                    } else {
                        return videoUrl
                    }
                }
            },

            filterPerRelatedQuestion() {

                return (page, question) => {
                    var allqs = []
                    for (var i = 0; i < this.survey.pages.length; i++) {
                        var p = this.survey.pages[i]
                        for (var j = 0; j < p.questions.length; j++) {
                            var q = p.questions[j]
                            allqs.push({ ...q, pageId: p.number })
                        }
                    }
                    var b = false
                    var bipolaranswer = ''

                    if (question.logic.filter(z => z.relatedQuestionId != null).length == 0)
                        b = true
                    else {
                        question.logic.forEach((l, index) => {

                            var rq = allqs.filter(x => x.reference == l.relatedQuestionId)
                            if (rq.length > 0) {
                                let relatedquestion = rq[0]
                                var condition = relatedquestion.selectedValue
                                if (l.operand && l.operand == 'and') {
                                    condition = b && relatedquestion.selectedValue
                                }
                                else if (l.operand && l.operand == 'or') {
                                    condition = b || relatedquestion.selectedValue
                                }
                                if (condition) {
                                    switch (relatedquestion.questionTypeId) {
                                        case FormMethodEnum.ShortAnswer:
                                        case FormMethodEnum.TextArea:
                                            if (l.operator == 'contains') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && relatedquestion.selectedValue.includes(l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || relatedquestion.selectedValue.includes(l.value)
                                                else {
                                                    b = b || relatedquestion.selectedValue.includes(l.value)
                                                }
                                            }
                                            else if (l.operator == 'notcontains') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && !relatedquestion.selectedValue.includes(l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || !relatedquestion.selectedValue.includes(l.value)
                                                else {
                                                    b = b || !relatedquestion.selectedValue.includes(l.value)
                                                }
                                            }
                                            else if (l.operator == 'starts') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && relatedquestion.selectedValue.startsWith(l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || relatedquestion.selectedValue.startsWith(l.value)
                                                else {
                                                    b = b || relatedquestion.selectedValue.startsWith(l.value)
                                                }
                                            }
                                            else if (l.operator == 'ends') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && relatedquestion.selectedValue.endsWith(l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || relatedquestion.selectedValue.endsWith(l.value)
                                                else {
                                                    b = b || relatedquestion.selectedValue.endsWith(l.value)
                                                }
                                            }
                                            else if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue == l.value)
                                                else {
                                                    b = b || (relatedquestion.selectedValue == l.value)
                                                }

                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue != l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue != l.value)
                                                else {
                                                    b = b || (relatedquestion.selectedValue != l.value)
                                                }

                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else {
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!relatedquestion.selectedValue)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!relatedquestion.selectedValue)
                                                else {
                                                    b = b || (!relatedquestion.selectedValue)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.Checkboxes:
                                            var selectedoption = relatedquestion.options.filter(x => relatedquestion.selectedValue.includes(x.id))

                                            var optiontext = undefined
                                            if (selectedoption.length > 0) {
                                                optiontext = selectedoption[0].name
                                            }
                                            if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && selectedoption.find(z => z.name == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || selectedoption.find(z => z.name == l.value)
                                                else {
                                                    b = b || selectedoption.find(z => z.name == l.value)
                                                }

                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && !selectedoption.find(z => z.name == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || !selectedoption.find(z => z.name == l.value)
                                                else {
                                                    b = b || !selectedoption.find(z => z.name == l.value)
                                                }

                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext && optiontext != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext && optiontext != '')
                                                else {
                                                    b = b || (optiontext && optiontext != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!optiontext)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!optiontext)
                                                else {
                                                    b = b || (!optiontext)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.Dropdown:
                                        case FormMethodEnum.TrickyQuestion:
                                        case FormMethodEnum.MultipleChoice:
                                            var selectedoption = relatedquestion.options.filter(x => relatedquestion.selectedValue == x.id)

                                            var optiontext = undefined
                                            if (selectedoption.length > 0) {
                                                optiontext = selectedoption[0].name
                                            }
                                            if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext == l.value)
                                                else {
                                                    b = b || (optiontext == l.value)
                                                }

                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext != l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext != l.value)
                                                else {
                                                    b = b || (optiontext != l.value)
                                                }

                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext && optiontext != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext && optiontext != '')
                                                else {
                                                    b = b || (optiontext && optiontext != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!optiontext)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!optiontext)
                                                else {
                                                    b = b || (!optiontext)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.PredefineDropdown:
                                            var selectedoption = relatedquestion.options.filter(x => x.id == relatedquestion.selectedValue)

                                            var optiontext = undefined
                                            if (selectedoption.length > 0) {
                                                optiontext = selectedoption[0].id.toString()
                                            }
                                            if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext == l.value)
                                                else {
                                                    b = b || (optiontext == l.value)
                                                }

                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext != l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext != l.value)
                                                else {
                                                    b = b || (optiontext != l.value)
                                                }

                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (optiontext && optiontext != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (optiontext && optiontext != '')
                                                else {
                                                    b = b || (optiontext && optiontext != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!optiontext)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!optiontext)
                                                else {
                                                    b = b || (!optiontext)
                                                }
                                            }

                                            break
                                        case FormMethodEnum.YesNo:
                                        case FormMethodEnum.Date:

                                            if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue == l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue == l.value)
                                                else {
                                                    b = b || (relatedquestion.selectedValue == l.value)
                                                }

                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue != l.value)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue != l.value)
                                                else {
                                                    b = b || (relatedquestion.selectedValue != l.value)
                                                }

                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else {
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!relatedquestion.selectedValue)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!relatedquestion.selectedValue)
                                                else {
                                                    b = b || (!relatedquestion.selectedValue)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.Rating:
                                        case FormMethodEnum.number:
                                            if (l.operator == 'lessthan') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue < parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue < parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue < parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'greaterthan') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue > parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue > parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue > parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue == parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue == parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue == parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue != parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue != parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue != parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else {
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!relatedquestion.selectedValue)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!relatedquestion.selectedValue)
                                                else {
                                                    b = b || (!relatedquestion.selectedValue)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.NPS:
                                            if (l.operator == 'lessthan') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue < parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue < parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue < parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'greaterthan') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue > parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue > parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue > parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'equal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue == parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue == parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue == parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'notequal') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue != parseInt(l.value))
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue != parseInt(l.value))
                                                else {
                                                    b = b || (relatedquestion.selectedValue != parseInt(l.value))
                                                }
                                            }
                                            else if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else {
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!relatedquestion.selectedValue)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!relatedquestion.selectedValue)
                                                else {
                                                    b = b || (!relatedquestion.selectedValue)
                                                }
                                            }
                                            break
                                        case FormMethodEnum.BipolarMatrix:
                                            allqs.filter(x => x.questionTypeId === this.bipolarMatrix).forEach(sub => {
                                                var options = sub.options.filter(x => JSON.parse(relatedquestion.selectedValue).find(z => z.selectedValue == x.id))
                                                options.forEach(option => {
                                                    var children = allqs.filter(x => x.questionTypeId === this.bipolarMatrix && x.options.filter(z => z.id == option.id).length > 0)

                                                    children.forEach(c => {
                                                        bipolaranswer += '|' + c.title + ':' + option.name
                                                        if (l.operator == 'equal') {
                                                            if (l.operand && l.operand == 'and')
                                                                b = b && (bipolaranswer.includes(l.value))
                                                            else if (l.operand && l.operand == 'or')
                                                                b = b || (bipolaranswer.includes(l.value))
                                                            else {
                                                                b = b || (bipolaranswer.includes(l.value))
                                                            }
                                                        }
                                                        else if (l.operator == 'notequal') {
                                                            if (l.operand && l.operand == 'and')
                                                                b = b && (!bipolaranswer.includes(l.value))
                                                            else if (l.operand && l.operand == 'or')
                                                                b = b || (!bipolaranswer.includes(l.value))
                                                            else {
                                                                b = b || (!bipolaranswer.includes(l.value))
                                                            }
                                                        }
                                                    })


                                                })
                                                if (l.operator == 'answered') {
                                                    if (l.operand && l.operand == 'and')
                                                        b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                    else if (l.operand && l.operand == 'or')
                                                        b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                    else {
                                                        b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                    }
                                                }
                                                else if (l.operator == 'notanswered') {
                                                    if (l.operand && l.operand == 'and')
                                                        b = b && (!relatedquestion.selectedValue)
                                                    else if (l.operand && l.operand == 'or')
                                                        b = b || (!relatedquestion.selectedValue)
                                                    else {
                                                        b = b || (!relatedquestion.selectedValue)
                                                    }
                                                }
                                            })


                                            break
                                        case FormMethodEnum.Image:
                                        case FormMethodEnum.VedioLink:
                                        case FormMethodEnum.Maps:
                                            if (l.operator == 'answered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                else {
                                                    b = b || (relatedquestion.selectedValue && relatedquestion.selectedValue != '')
                                                }
                                            }
                                            else if (l.operator == 'notanswered') {
                                                if (l.operand && l.operand == 'and')
                                                    b = b && (!relatedquestion.selectedValue)
                                                else if (l.operand && l.operand == 'or')
                                                    b = b || (!relatedquestion.selectedValue)
                                                else {
                                                    b = b || (!relatedquestion.selectedValue)
                                                }
                                            }
                                            break

                                    }
                                }
                                else {
                                    if (l.operator == 'notanswered') {
                                        b = true
                                    }
                                    else
                                        b = false
                                }
                                if (b) {
                                    b = relatedquestion.show == undefined || (relatedquestion.show == true)
                                }

                            }
                        })

                    }
                    question.show = b
                    if (!b)
                        question.selectedValue = null
                    return b

                }
            }
        },

        watch: {
            'mapLocation': {
                handler(val) {
                    this.location = { coords: { latitude: val.lat, longitude: val.lng } }
                }
            },
            'survey.pages': {
                handler(val) {
                    for (var i = 0; i < this.survey.pages.length; i++) {
                        let currentPage = this.survey.pages[i]
                        if (currentPage) {
                            for (var j = 0; j < currentPage.questions.length; j++) {
                                let currentQuestion = currentPage.questions[j]
                                if (currentQuestion && currentQuestion.questionTypeId == this.predefineDropdown) {
                                    this.predefineDropdownItemsPage(currentQuestion)
                                }
                            }
                        }
                    }

                }
            },
        },
        methods: {
            getQuestionLabel(question) {
                if (!question) {
                    return ''
                }
                const title = question.title || ''
                if (!title) {
                    return ''
                }
                return question.required ? `${title} *` : title
            },
            evaluateSinglePageState() {
                // Hide stepper/pagination when there is exactly one page and it has no visible title
                if (this.survey && this.survey.pages && this.survey.pages.length === 1) {
                    const page = this.survey.pages[0]
                    const localized = this.language === 'ar' ? page.nameAr : page.nameEn
                    const name = localized || page.name
                    const title = name ? String(name).trim() : ''
                    this.singlePageWithoutTitle = title.length === 0
                } else {
                    this.singlePageWithoutTitle = false
                }
            },
            GetCurrentPageName() {

                var currentpage = this.survey.pages.filter(x => x.number == this.surveyStepper)

                if (currentpage) {

                    this.currentpagename = currentpage[0].name
                }
                else
                    this.currentpagename = ''
            },
            handleCheckboxValidation(isValid) {
                this.isCheckboxValid = isValid
            },
            handleInputContact(updatedValue) {

                this.selectedContactForm = updatedValue
            },

            handleSelectedImages(images) {
                this.selectedImages = images
            },

            handleUploadSuccess(response) {
                //console.log('Upload successful in parent:', response)
            },

            async getSavedAnswers() {
                var allqs = []
                for (var i = 0; i < this.survey.pages.length; i++) {
                    var p = this.survey.pages[i]
                    for (var j = 0; j < p.questions.length; j++) {
                        var q = p.questions[j]
                        allqs.push({ ...q, pageId: p.number })
                    }
                }
                var myanswers = await SurveyService.listMyAnswers(this.participantId)

                for (var i = 0; i < this.survey.pages.length; i++) {
                    let currentPage = this.survey.pages[i]
                    if (currentPage) {
                        for (var j = 0; j < currentPage.questions.length; j++) {
                            let currentQuestion = currentPage.questions[j]
                            var answer = myanswers.data.filter(x => x.questionId == currentQuestion.id)
                            console.log('ANSWERRS', answer)
                            if (answer.length > 0) {
                                let updatedValue
                                switch (currentQuestion.questionTypeId) {
                                    case FormMethodEnum.ShortAnswer:
                                    case FormMethodEnum.TextArea:
                                    case FormMethodEnum.YesNo:
                                    case FormMethodEnum.Date:
                                    case FormMethodEnum.Image:
                                    case FormMethodEnum.HijriDate:
                                    case FormMethodEnum.EmailInput:
                                    case FormMethodEnum.Urls:
                                    case FormMethodEnum.VedioLink:
                                    case FormMethodEnum.Consent:
                                    case FormMethodEnum.PhoneNumber:
                                    case FormMethodEnum.ContactForm:
                                        updatedValue = answer[0].answer
                                        break
                                    case FormMethodEnum.Maps:
                                        updatedValue = answer[0].answer
                                        while (!google) { }
                                        const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                                        placesService.textSearch({ query: answer[0].answer }, (results, status) => {
                                            if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length) {
                                                const place = results[0]
                                                this.markerPosition = {
                                                    lat: place.geometry.location.lat(),
                                                    lng: place.geometry.location.lng(),
                                                }
                                                this.mapCenter = this.markerPosition
                                            }
                                        })

                                        break
                                    case FormMethodEnum.Checkboxes:
                                        var arr = []
                                        for (i = 0; i < answer.length; i++) {
                                            var selectedoption = currentQuestion.options.filter(x => x.id == answer[i].optionId)
                                            arr.push(selectedoption[0].id)
                                        }
                                        updatedValue = arr
                                        break
                                    case FormMethodEnum.MultipleChoice:
                                    case FormMethodEnum.Dropdown:
                                    case FormMethodEnum.TrickyQuestion:
                                    case FormMethodEnum.BipolarMatrix:

                                        var selectedoption = currentQuestion.options.filter(x => x.id == answer[0].optionId)
                                        if (selectedoption.length > 0) {
                                            updatedValue = selectedoption[0].id
                                        }
                                        break
                                    case FormMethodEnum.NPS:
                                        updatedValue = answer[0].answer
                                        break
                                    case FormMethodEnum.PredefineDropdown:
                                        await this.predefineDropdownItemsPage(currentQuestion)
                                        var lookupitems = answer[0].lookupItemIds

                                        this.renderPredefinedAnswer(currentQuestion, lookupitems)


                                        break
                                    case FormMethodEnum.Rating:
                                    case FormMethodEnum.number:
                                        updatedValue = parseInt(answer[0].answer.replaceAll('Rating#', ''))
                                        break


                                }

                                // Use Vue.set to ensure reactivity
                                if (updatedValue !== undefined) {
                                    this.$set(currentQuestion, 'selectedValue', updatedValue)

                                }
                            }
                        }
                    }
                }
                // Force a re-render if necessary
                this.$forceUpdate()
            },

            async renderPredefinedAnswer(currentQuestion, lookupitems) {

                var selectedoption = currentQuestion.options.filter(x => lookupitems.split(',').find(q => x.id == q))
                if (selectedoption.length) {
                    var selectedValueOption = selectedoption[0].id

                    this.$set(currentQuestion, 'selectedValue', selectedValueOption)
                    await this.handlePredefineDropdownChange(currentQuestion, selectedValueOption, true, currentQuestion)
                    var count = this.relatedPredefinedQuestions.filter(x => x.id == currentQuestion.id)[0].relatedQuestions.length
                    this.renderSubPredefinedAnswer(count, currentQuestion, lookupitems)


                }
            },

            renderSubPredefinedAnswer(count, currentQuestion, lookupitems) {
                this.relatedPredefinedQuestions.filter(x => x.id == currentQuestion.id)[0].relatedQuestions.map(async (x) => {



                    var selectedoptionx = x.options.filter(so => lookupitems.split(',').find(q => so.id == q))
                    var selectedValueOptionx = selectedoptionx[0].id

                    this.$set(x, 'selectedValue', selectedValueOptionx)
                    await this.handlePredefineDropdownChange(currentQuestion, selectedValueOptionx, false, x)
                    //alert(count + '|' + this.relatedPredefinedQuestions.filter(x => x.id == currentQuestion.id)[0].relatedQuestions.length)
                    if (count < this.relatedPredefinedQuestions.filter(x => x.id == currentQuestion.id)[0].relatedQuestions.length) {
                        count = this.relatedPredefinedQuestions.filter(x => x.id == currentQuestion.id)[0].relatedQuestions.length
                        this.renderSubPredefinedAnswer(count, currentQuestion, lookupitems)
                    }

                })
            },

            updateMap() {
                if (!this.searchQuery) return
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                placesService.textSearch({ query: this.searchQuery }, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length) {
                        const place = results[0]
                        this.markerPosition = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        }
                        this.mapCenter = this.markerPosition
                    }
                })
            },

            placeMarker(event) {
                this.markerPosition = {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng(),
                }
                this.mapCenter = this.markerPosition
            },

            answerLocation(question) {
                question.selectedValue = `${this.mapCenter.lat},${this.mapCenter.lng}`
            },

            goBack() {
                if (this.$route.query.viewMode && !this.$route.query.fromTask)
                    this.$router.push('/add-survey?id=' + this.$route.query.id)
                else if (this.$route.query.participantId) {
                    var i = this.$route.query.id
                    this.$router.push({ name: 'survey-results', params: { id: i } })
                }
                else {
                    history.back()
                }

            },

            getYouTubeVideoId(url) {
                // Extract video ID from YouTube link
                const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
                const match = url.match(regExp)
                if (match && match[2].length === 11) {
                    return match[2]
                } else {
                    // Handle invalid YouTube URLs
                    console.error('Invalid YouTube URL')
                    return ''
                }
            },

            getVimeoVideoId(url) {
                // Extract video ID from Vimeo link
                const regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/
                const match = url.match(regExp)
                if (match) {
                    return match[2]
                } else {
                    // Handle invalid Vimeo URLs
                    console.error('Invalid Vimeo URL')
                    return ''
                }
            },

            updateParentQuestion(qIndex, selectedValue, question) {
                var answers = JSON.parse(question.selectedValue)

                if (!answers) {
                    answers = [{ qIndex, selectedValue }]
                }
                else {

                    var index = answers.findIndex(x => x.qIndex == qIndex)
                    if (index !== -1) {

                        // Update the properties of the object
                        Object.assign(answers[index], { qIndex, selectedValue })
                        // Alternatively, if you want to replace the entire object:
                        // array[index] = { ...array[index], ...updatedProperties };
                    } else {

                        answers.push({ qIndex, selectedValue })
                    }
                }
                question.selectedValue = JSON.stringify(answers)
            },

            starClicked(value, question) {
                question.selectedValue = value
            },

            validateCustomComponents(pageNumber) {
                // Clear previous errors
                this.customComponentErrors = {}

                // Get the current page
                const currentPage = this.survey.pages.find(p => p.number === pageNumber)
                if (!currentPage) return true

                let isValid = true

                // Check each question on the current page
                currentPage.questions.forEach(question => {
                    // Check if question is visible based on filterPerRelatedQuestion
                    if (!this.filterPerRelatedQuestion(currentPage, question)) {
                        return // Skip hidden questions
                    }

                    // Validate YesNo (LikeDislike) component
                    if (question.questionTypeId === this.yesNo && question.required) {
                        if (!question.selectedValue || (question.selectedValue !== 'yes' && question.selectedValue !== 'no')) {
                            this.$set(this.customComponentErrors, question.id, true)
                            isValid = false
                        }
                    }

                    // Validate NPS component
                    if (question.questionTypeId === this.nps && question.required) {
                        if (!question.selectedValue || question.selectedValue.includes('#')) {
                            // NPS value is just a number when selected, or contains # when not selected
                            const value = question.selectedValue
                            if (!value || value === '' || value.includes('#') || isNaN(parseInt(value))) {
                                this.$set(this.customComponentErrors, question.id, true)
                                isValid = false
                            }
                        }
                    }
                })

                return isValid
            },

            nextStep(n) {
                var formValid = this.isCheckboxValid && this.$refs.surveyVoteForm[n - 1].validate()
                var customComponentsValid = this.validateCustomComponents(n)
                var valid = formValid && customComponentsValid

                if (!valid) {
                    this.$nextTick(() => {
                        const el = this.$el.querySelector('.error--text, .validation-error, .nps-validation-error')
                        if (el) {
                            this.$vuetify.goTo(el)
                        }
                        return
                    })
                }
                else {
                    if (n === this.steps) {
                        this.surveyStepper = 1
                    }
                    else {
                        this.surveyStepper = n + 1
                    }
                }
                this.GetCurrentPageName()
            },

            previousStep(n) {
                if (n > 1) {
                    this.surveyStepper = n - 1
                }
                this.GetCurrentPageName()
            },

            async complete(isDraft) {
                var formValid = this.isCheckboxValid && this.$refs.surveyVoteForm[this.steps - 1].validate()
                var customComponentsValid = this.validateCustomComponents(this.steps)
                var valid = formValid && customComponentsValid

                if (!valid) {
                    this.$nextTick(() => {
                        const el = this.$el.querySelector('.error--text, .validation-error, .nps-validation-error')
                        if (el) {
                            this.$vuetify.goTo(el)
                        }
                        return
                    })
                }

                else {
                    if (this.gettingLocation == false) {
                        if (await this.$root.$confirm(this.$t('Save'), this.$t('Geolocation is not available. Are you sure you want to continue'))) {
                            this.loading = true
                            var result = this.wrapQuestions()
                            var language = this.getLanguage
                            SurveyService.vote(this.$route.query.id, result, '000', '000', this.startTime, isDraft, this.participantId).then((res) => {

                                this.submitted = !isDraft
                                var savedSurveyAnswers = []
                                var surveysVoted = []
                                var voted = Cookies.get('surveysVoted')
                                var answers = Cookies.get('savedSurveyAnswers')
                                if (answers) {
                                    savedSurveyAnswers = JSON.parse(answers)
                                }
                                if (voted) {
                                    surveysVoted = JSON.parse(voted)
                                }
                                if (isDraft) {
                                    if (!savedSurveyAnswers.find(x => x.participantId == res.participantId)) {
                                        savedSurveyAnswers.push({ surveyId: this.$route.query.id, participantId: res.participantId })
                                    }
                                }
                                else {
                                    savedSurveyAnswers = savedSurveyAnswers.filter(x => x.participantId != res.participantId)
                                    var votefound = surveysVoted.filter(x => x.surveyId == this.$route.query.id)
                                    if (votefound.length > 0) {
                                        votefound.map(x => x.count++)
                                    }
                                    else {
                                        votefound.push({ surveyId: this.$route.query.id, count: 1 })
                                    }
                                    Cookies.set('surveysVoted', JSON.stringify(votefound), { expires: 36500 })
                                }
                                if (savedSurveyAnswers.length > 0)
                                    Cookies.set('savedSurveyAnswers', JSON.stringify(savedSurveyAnswers), { expires: 36500 })
                                else {
                                    Cookies.remove('savedSurveyAnswers')
                                }
                            }).catch(() => {
                                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                            }).finally(() => {
                                this.loading = false
                            })
                        }
                    } else {
                        this.loading = true
                        var result = this.wrapQuestions()
                        if (this.location) {
                            SurveyService.vote(this.$route.query.id, result, this.location.coords.latitude, this.location.coords.longitude, this.startTime, isDraft, this.participantId).then((res) => {
                                this.submitted = !isDraft
                                var savedSurveyAnswers = []
                                var surveysVoted = []
                                var voted = Cookies.get('surveysVoted')
                                var answers = Cookies.get('savedSurveyAnswers')
                                if (answers) {
                                    savedSurveyAnswers = JSON.parse(answers)
                                }
                                if (voted) {
                                    surveysVoted = JSON.parse(voted)
                                }
                                if (isDraft) {
                                    if (!savedSurveyAnswers.find(x => x.participantId == res.participantId)) {
                                        savedSurveyAnswers.push({ surveyId: this.$route.query.id, participantId: res.participantId })
                                    }
                                }
                                else {
                                    savedSurveyAnswers = savedSurveyAnswers.filter(x => x.participantId != res.participantId)
                                    var votefound = surveysVoted.filter(x => x.surveyId == this.$route.query.id)
                                    if (votefound.length > 0) {
                                        votefound.map(x => x.count++)
                                    }
                                    else {
                                        votefound.push({ surveyId: this.$route.query.id, count: 1 })
                                    }
                                    Cookies.set('surveysVoted', JSON.stringify(votefound), { expires: 36500 })
                                }
                                if (savedSurveyAnswers.length > 0)
                                    Cookies.set('savedSurveyAnswers', JSON.stringify(savedSurveyAnswers), { expires: 36500 })
                                else {
                                    Cookies.remove('savedSurveyAnswers')
                                }
                            }).catch(() => {
                                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                            }).finally(() => {
                                this.loading = false
                            })
                        } else {
                            this.loading = true
                            var result = this.wrapQuestions()
                            SurveyService.vote(this.$route.query.id, result, '000', '000', this.startTime, isDraft, this.participantId).then((res) => {
                                this.submitted = true
                            }).catch(() => {
                                this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                            }).finally(() => {
                                this.loading = false
                            })
                        }

                    }


                }
                this.GetCurrentPageName()
            },

            wrapQuestions() {
                let postQuestions = []
                for (let i = 0; i < this.survey.pages.length; i++) {
                    let currentPage = this.survey.pages[i]
                    if (currentPage) {
                        for (let j = 0; j < currentPage.questions.length; j++) {
                            let currentQuestion = currentPage.questions[j]
                            if (currentQuestion) {
                                if (currentQuestion.questionTypeId === this.predefineDropdown) {
                                    let filteredQuestion = this.relatedPredefinedQuestions.find(x => x.id === currentQuestion.id)
                                    if (filteredQuestion && filteredQuestion.relatedQuestions) {
                                        currentQuestion.lookupItemIds = filteredQuestion.relatedQuestions.map(s => s.selectedValue).reverse()
                                    }
                                } else if (currentQuestion.questionTypeId === FormMethodEnum.PictureChoice) {

                                    const selectedPicture = currentQuestion.questionPictures.find(picture => picture.isSelected)

                                    const selectedId = selectedPicture ? selectedPicture.imageId : null

                                    currentQuestion.selectedValue = selectedId
                                } else if (currentQuestion.questionTypeId === FormMethodEnum.ContactForm) {

                                    currentQuestion.selectedValue = this.selectedContactForm
                                } else if (currentQuestion.questionTypeId === FormMethodEnum.Ranking) {

                                    currentQuestion.selectedValue = currentQuestion.default
                                }
                                postQuestions.push(currentQuestion)
                            }
                        }
                    }
                }
                return postQuestions
            },

            loadSurveyForm(id) {
                this.loading = true
                var language = this.getLanguage
                SurveyService.getPublicSurveyFormById(id, language).then((res) => {
                    if (res.data) {

                        this.survey = res.data
                        this.steps = res.data.pages.length

                        /*if (this.steps > 3 && window.innerWidth<995) {
                            this.showpagetitle = false
                        }*/
                        this.evaluateSinglePageState()
                        if (this.$route.query.editMode) {
                            this.editMode = this.$route.query.editMode
                        }
                        if (this.$route.query.participantId) {
                            this.participantId = this.$route.query.participantId
                            this.getSavedAnswers()
                        }
                        this.GetCurrentPageName()
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                    this.pageloading = false
                })
            },

            loadSurveyPreview(id) {
                this.loading = true
                var language = this.getLanguage
                SurveyService.previewSurveyFormById(id, language).then((res) => {
                    if (res.data) {
                        
                        this.survey = res.data
                        this.steps = res.data.pages.length
                        this.evaluateSinglePageState()
                        this.GetCurrentPageName()
                        /*if (this.steps > 3 && window.innerWidth < 995) {
                            this.showpagetitle = false
                        }*/
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                    this.pageloading = false
                })
            },

            async predefineDropdownItemsPage(currentQuestion) {
                try {
                    var res = await LookupAdminService.listSurveyLookupItems(currentQuestion.lookupId)
                    currentQuestion.options = res.data
                }
                catch {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }
                this.loading = false
            },

            async handlePredefineDropdownChange(question, selectedValueOption, isMain, item) {
                let titleDrop = item.title

                // Find or create the main question entry
                let existingQuestion = this.relatedPredefinedQuestions.find(x => x.id === question.id)
                if (!existingQuestion) {
                    this.relatedPredefinedQuestions.push({ id: question.id, optionId: selectedValueOption, relatedQuestions: [] })
                    existingQuestion = this.relatedPredefinedQuestions.find(x => x.id === question.id)
                }

                if (isMain) {
                    if (question.lookupId != item.questionTypeParams) {
                        existingQuestion.relatedQuestions = []
                        if (selectedValueOption) {
                            var res = await LookupAdminService.listLookupItemsIfHasChild(selectedValueOption)
                            if (res.data) {
                                existingQuestion.relatedQuestions.push({
                                    title: res.data.lookupName,
                                    selectedValue: null,
                                    options: res.data.listItems,
                                    stopId: res.data.lookupId
                                })
                            }
                        }
                    }
                } else {
                    if (item.stopId != question.questionTypeParams) {
                        if (selectedValueOption) {
                            var res = await LookupAdminService.listLookupItemsIfHasChild(selectedValueOption)
                            if (res.data) {
                                let relatedQuestionExists = existingQuestion.relatedQuestions.some(q => q.title === res.data.lookupName && q.stopId === res.data.lookupId)
                                if (!relatedQuestionExists) {
                                    existingQuestion.relatedQuestions.push({
                                        title: res.data.lookupName,
                                        selectedValue: null,
                                        options: res.data.listItems,
                                        stopId: res.data.lookupId
                                    })
                                }
                            } else {
                                existingQuestion.relatedQuestions = existingQuestion.relatedQuestions.filter(q => q.title === titleDrop)
                            }
                        }
                    }
                }
            },

            getLocation() {
                if (!('geolocation' in navigator)) {
                    this.errorStr = 'Geolocation is not available.'
                    return
                }
                this.gettingLocation = true

                navigator.geolocation.getCurrentPosition(pos => {
                    this.gettingLocation = true
                    this.location = pos
                    this.mapCenter.lat = pos.coords.latitude
                    this.mapCenter.lng = pos.coords.longitude
                    this.mapLocation = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    }
                    this.markerPosition = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    }
                }, err => {
                    this.gettingLocation = false
                    this.errorStr = err.message
                })
            },
            valueInRange(value) {
                const int32Min = -2147483648
                const int32Max = 2147483647
                if (value === null || value === '' || isNaN(value)) return true // No validation if empty
                const numberValue = Number(value)
                if (numberValue < int32Min || numberValue > int32Max) {
                    return `Value must be between ${int32Min} and ${int32Max}`
                }
                return true
            }
        },
    }
</script>

<style>
    
    .formcontainer {
        width: 80%;
        margin-top: -130px
    }
    .formactions{
        justify-content:center;
        flex-direction:row !important
    }
    .cardtitle {
        width: 100vw;
        min-height: 8rem;
    }
    .cardtitle h3{
        width:100%;
        text-align:center;
    }
    .showonmobile{
        display:none
    }
    @media(max-width:959.98px)
    {
        .v-stepper__label {
            display: block !important;
            font-size: 12px;
            padding-left: 5px;
            padding-right: 5px;
        }
        .v-stepper__step__step {
            font-size: 12px !important;
            width: 20px !important;
            height: 22px !important;
        }
        .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon{
            font-size:15px;
        }
        .theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
            width: 20px !important;
            height: 22px !important;
            font-size: 12px !important;
        }
        .stepper-bg .theme--light.v-divider {
            margin: 0 10px !important;
        }
    }
    @media(max-width:768px)
    {
        .v-stepper__content {
            padding-right: 0px !important;
            padding-left: 0px;
        }
        .formactions button {
            width: 45% !important
        }
        .formcontainer {
            width: 100%;
        }
        .showonmobile {
            display: block
        }
        .showonmobile .v-btn{
            margin-right:0px !important;
            margin-left:0px !important;
        }
        .showondesktop{
            display:none
        }
    }
    .back-button {
        color: white;
        background-color: #1976D2;
    }

    .options {
        border: 0
    }

    /* Make all option labels bolder and darker */
    .v-radio label,
    .v-checkbox label,
    .v-label {
        font-weight: 700 !important;
        color: #404040 !important;
        text-align:right
    }

    .preview-image {
        width: 500px; /* Adjust the size as needed */
        height: 500px; /* Adjust the size as needed */
    }
    .stepper-bg {
        background-color: #fff;
        border-radius: 0.5rem;
        box-shadow: inset 0 0 0 0.0625rem #D2D6DB;
        padding: 20px 40px;
        width: 100%;
        height: fit-content;
    }
        .stepper-bg.gray {
            background-color: #FCFCFD
        }
    .theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {
        border: 1px solid #1B8354;
        color: #1B8354;
        background:none!important;
    }
    
    .v-application--is-rtl .theme--light.v-stepper--vertical .v-stepper__content:not(:last-child) {
        border-right: 0!important;
    }
   
   .stepper-bg .theme--light.v-divider {
    border: 1px solid #1B8354;
    height: 58px;
    margin: 0 20px;
   }
    .v-application--is-ltr.theme--light .stepper-bg .theme--light.v-divider {
        margin: 0 20px;
    }
   .v-stepper .v-stepper__step__step.primary {
    background-color: #1B8354!important;
   }
   .v-application--is-ltr .theme--light.v-stepper--vertical .v-stepper__content:not(:last-child) {
    border-left: 0!important;
   }

   /* Bold answer options (radio, checkbox, etc.) */
   .v-radio >>> label,
   .v-checkbox >>> label,
   .v-input--radio-group >>> .v-label,
   .v-input--checkbox >>> .v-label {
    font-weight: 700 !important;
   }

   /* Additional selectors for multiple choice and checkbox options */
   .v-radio label,
   .v-checkbox label,
   .v-input--radio-group .v-label,
   .v-input--selection-controls__ripple + .v-label,
   .v-radio .v-label,
   .v-checkbox .v-label {
    font-weight: 700 !important;
   }

   /* Deep selectors using different syntax */
   ::v-deep .v-radio label,
   ::v-deep .v-checkbox label,
   ::v-deep .v-input--radio-group .v-label,
   ::v-deep .v-input--checkbox .v-label {
    font-weight: 700 !important;
   }

   /* Dropdown (v-autocomplete) options in menu list */
   .v-autocomplete .v-list-item__title,
   .v-select .v-list-item__title,
   ::v-deep .v-autocomplete .v-list-item__title,
   ::v-deep .v-select .v-list-item__title {
    font-weight: 700 !important;
   }

   /* BipolarMatrix options - Desktop table headers */
   .bipolar-header-option {
    font-weight: 700 !important;
   }

   /* BipolarMatrix options - Mobile view labels */
   .bipolar-mobile-option-label {
    font-weight: 700 !important;
   }
</style>

<style scoped>
h3 {
    font-size: 30px;
    font-family: IBMPlexSansArabic-SemiBold;
}
/* Centering the step container */
.step-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Center vertically */
}

/* The step card */
.step-card {
  display: flex;
  align-items: center;
  background: #f8f9fa; /* Soft white */
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 350px;
  width: 100%;
}

/* Progress circle styling */
.progress-circle {
  position: relative;
  width: 40px;
  height: 40px;
  margin-right: 12px;
}

svg {
  transform: rotate(-90deg);
}

.bg-circle {
  fill: none;
  stroke: #e0e0e0;
  stroke-width: 3;
}

.progress-bar {
  fill: none;
  stroke: #0a6;
  stroke-width: 3;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.3s ease;
}

.step-text {
  font-size: 10px;
  fill: black;
  font-weight: bold;
  dominant-baseline: middle;
}

/* Step info styles */
.step-info {
  flex-grow: 1;
}

.step-title {
  font-size: 14px;
  font-weight: bold;
}

.step-description {
  font-size: 12px;
  color: #666;
}

.next-step {
  font-size: 12px;
  color: #999;
}
.v-progress-circular__info {
    font-size: 14px;
    color: #384250;
    font-family: IBMPlexSansArabic-Regular !important;
}
.survey-form {
    width: 47%;
}
.v-application .primary--text {
    color: #1B8354 !important;
    caret-color: #1B8354 !important;
}
    .form-label {
        padding: 0 0 15px 0;
    }
@media only screen and (max-width: 1185px) {
    .survey-form {
    width: 100%;
}
@media only screen and (max-width: 960px){
    
    .v-card__actions > .v-btn.v-btn {
        width: 100%;
        margin-bottom: 10px;
    }
    .v-card__actions {
        flex-direction: column;
    }
    .v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
        padding-left: 0!important;
    }
}

}

/* Bipolar Matrix Mobile Responsive Styles */
.bipolar-matrix-container {
    width: 100%;
}

/* Desktop view - Table with horizontal scroll */
.bipolar-desktop-view {
    display: block;
}

.bipolar-mobile-view {
    display: none;
}

.table-wrapper {
    overflow-x: auto;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-wrapper::-webkit-scrollbar {
    height: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb {
    background: #0a716e;
    border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #085a57;
}

.bipolar-header-title {
    min-width: 200px;
    background-color: #f5f7fa;
    font-weight: 600;
    padding: 16px !important;
}

.bipolar-header-option {
    min-width: 100px;
    background-color: #f5f7fa;
    font-weight: 600;
    padding: 12px !important;
    white-space: nowrap;
}

.bipolar-question-cell {
    min-width: 200px;
    padding: 12px 16px !important;
    font-weight: 500;
    background-color: #fafbfc;
}

.bipolar-option-cell {
    min-width: 100px;
    padding: 8px !important;
    text-align: center;
    vertical-align: middle;
}
    
    /* Mobile responsive - Switch to card layout */
    @media only screen and (max-width: 768px) {
        .bipolar-desktop-view {
        display: none;
    }

    .bipolar-mobile-view {
        display: block;
    }

    .bipolar-mobile-title {
        font-size: 18px;
        font-weight: 600;
        color: #384250;
        padding: 0 8px;
    }

    .bipolar-mobile-card {
        border-radius: 12px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        transition: all 0.3s ease;
    }

    .bipolar-mobile-card:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
    }

    .bipolar-mobile-question-title {
        font-size: 16px;
        font-weight: 600;
        color: #1B8354;
        line-height: 1.5;
    }

    .bipolar-mobile-options {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .bipolar-mobile-radio {
        margin: 0 !important;
        padding: 12px;
        border-radius: 8px;
        background: #f8f9fa;
        transition: all 0.3s ease;
    }

    .bipolar-mobile-radio:hover {
        background: #e9ecef;
    }

    .bipolar-mobile-option-label {
        font-size: 15px;
        color: #384250;
        font-weight: 500;
    }
}

/* Tablet view - Keep table but optimize */
@media only screen and (min-width: 769px) and (max-width: 1024px) {
    .bipolar-header-title {
        min-width: 150px;
        font-size: 14px;
    }

    .bipolar-header-option {
        min-width: 80px;
        font-size: 13px;
    }

    .bipolar-question-cell {
        min-width: 150px;
        font-size: 14px;
    }

    .bipolar-option-cell {
        min-width: 80px;
    }
}
</style>